<template>
  <pt-news-manage class="pt-news-manage__withData" :newsCategories="newsCategories" @deleteNews="deleteNews" ref="newsTable" @publish="publish" @disabled="disabled"
  :isTitle="isTitle" :tableParams="paramsData" @setStick="setStick" @cancelStick="cancelStick"  @goodsRecommend="goodsRecommend" @toolsVisibleChange="toolsVisibleChange" @actionVisibleChange="actionVisibleChange"></pt-news-manage>
</template>

<script>
import PtNewsManage from './index'
export default {
  name: 'pt-news-manage__withData',
  components: {
    'pt-news-manage': PtNewsManage
  },
  props: {
    isTitle: {
      type: Boolean,
      default: true
    },
    paramsData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      newsCategories: []
    }
  },
  methods: {
    getGoodsRecommend (val) {
      this.$store.dispatch('NewsRecommend', val.id).then(res => {
        val.isHomePageVisible = true
      }).catch(err => {
        this.$message.error(err || '首页展示新闻失败')
      })
    },
    getGoodsRecommendCancel (val) {
      this.$store.dispatch('NewsRecommendCancel', val.id).then(res => {
        val.isHomePageVisible = false
      }).catch(err => {
        this.$message.error(err || '首页展示新闻失败')
      })
    },
    goodsRecommend (val) {
      if (val.isHomePageVisible) {
        this.getGoodsRecommendCancel(val)
      } else {
        this.getGoodsRecommend(val)
      }
    },
    setStick (val) {
      this.$store.dispatch('setNewsStick', val.id).then(res => {
        val.isStick = true
        this.$message.success('置顶新闻成功')
      }).catch(err => {
        this.$message.error(err || '置顶新闻失败')
      })
    },
    cancelStick (val) {
      this.$store.dispatch('cancelNewsStick', val.id).then(res => {
        val.isStick = false
        this.$message.success('取消新闻置顶成功')
      }).catch(err => {
        this.$message.error(err || '取消新闻置顶失败')
      })
    },
    disabled (val) {
      this.$store.dispatch('disabledNews', val.id).then(res => {
        this.$message.success('下架新闻成功')
        this.$refs.newsTable.getNewsList()
      }).catch(err => {
        this.$message.error(err || '下架新闻失败')
      })
    },
    publish (val) {
      this.$store.dispatch('publishNews', val.id).then(res => {
        this.$message.success('发布新闻成功')
        this.$refs.newsTable.getNewsList()
      }).catch(err => {
        this.$message.error(err || '发布新闻失败')
      })
    },
    getNewCategories () {
      this.$store.dispatch('newCategories').then(res => {
        this.newsCategories = res
      }).catch(err => {
        this.$message.error(err || '获取新闻分类失败')
      })
    },
    deleteNews (id) {
      this.$store.dispatch('deleteNews', id).then(res => {
        this.$message.success('删除新闻成功')
        this.$refs.newsTable.getNewsList()
      }).catch(err => {
        this.$message.error(err || '删除新闻失败')
      })
    },
    toolsVisibleChange (data) {
      let params = {
        id: data.id,
        visible: !data.toolsCenterVisible
      }
      this.$store.dispatch('updateNewsShowTools', params).then(res => {
        this.$message.success('状态更新成功')
        this.$refs.newsTable.getNewsList()
      }).catch(err => {
        this.$message.error(err || '状态更新失败')
      })
    },
    actionVisibleChange (data) {
      let params = {
        id: data.id,
        visible: !data.actionCenterVisible
      }
      this.$store.dispatch('updateNewsShowActionCenter', params).then(res => {
        this.$message.success('状态更新成功')
        this.$refs.newsTable.getNewsList()
      }).catch(err => {
        this.$message.error(err || '状态更新失败')
      })
    }
  },
  created () {
    this.getNewCategories()
  }
}
</script>
